<ng-container *ngIf="iconOnly">
    <button mat-icon-button color="accent"
            [color]="color"
            class="button"
            [disabled]="disabled && !(exercice.video_path || exercice.video_url)"
            (click)="onPlayVideoClicked()"
    >
        <mat-icon *ngIf="icon" matTooltip="{{ title | translate }}" class="icon">{{ icon }}</mat-icon>
    </button>
</ng-container>

<ng-container *ngIf="!iconOnly">
    <button mat-raised-button
            [color]="color"
            [disabled]="disabled && !(exercice.video_path || exercice.video_url)"
            (click)="onPlayVideoClicked()">
        <div class="centered">
            <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
            <span>{{ title | translate }}</span>
        </div>
    </button>
</ng-container>

